import axios from 'axios';
import { find } from 'lodash';

export default {
  namespaced: true,

  state: {
    all: {},
  },

  getters: {
    getAll(state) {
      return state.all;
    },
    getById: (state) => (id) => {
      return find(state.all, valve => valve.id === id);
    },
  },

  actions: {
    index({ commit }) {
      return axios.get(process.env.VUE_APP_API_URL + 'additional-valves')
        .then(({ data }) => {
          commit('SET_ADDITIONAL_VALVES', data);
        });
    },
  },
  mutations: {
    SET_ADDITIONAL_VALVES(state, payload) {
      payload.forEach((v) => {
        state.all[v.id] = v;
      });
    },
  },
};
